import * as React from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import '../styles/Modal.scss'
import CameraIcon from '../assets/imgs/profile-screen-images/camera-icon.svg'
import CreateServiceCameraIcon from '../assets/imgs/create-service-camera-icon.svg'

import {
  Button,
  FormHelperText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import SetSkillRateModal from './SetSkillRateModal'
import NewServiceModal from './NewServiceModal'
import { getDataById, saveOrUpdateDataById } from '../apis/generalApis'
import DeleteIcon from '@mui/icons-material/Delete'
import Swal from 'sweetalert2'
import { ScaleLoader } from 'react-spinners'
import ClearIcon from '@mui/icons-material/Clear'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  maxHeight: '90vh',
  overflow: 'auto',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: '0px 5px 20px #00000040',
  p: 4,
  outline: 'none',
  borderRadius: '16px',
  textAlign: 'center',
}

const CreateServiceModal = ({
  handleCreateServiceModal,
  createServiceModal = false,
  component = '',
  service,
  getStylistServices,
  isNewService = false,
  // handleAddOrEditSkillsModal,
}) => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [formData, setFormData] = React.useState(new FormData())
  const [servicesList, setServicesList] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)
  const [servicePriceModal, setServicePriceModal] = React.useState(false)
  const [newServiceModal, setNewServiceModal] = React.useState(false)
  const [serviceData, setServiceData] = React.useState({
    ...service,
    primary_image_url: '',
  })
  const [rates, setRates] = React.useState([])
  const [selectedSubService, setSelectedSubService] = React.useState(null)

  const [skillRate, setSkillRate] = React.useState({
    small: '',
    medium: '',
    large: '',
    add_on: '',
  })

  React.useEffect(() => {
    setRates(service?.category)
    setServiceData({
      ...service,
    })
  }, [service])

  const [newService, setNewService] = React.useState(
    service?.service ?? {
      service_id: '',
      sub_service_id: '',
      stylist_id: user?.id,
      description: '',
      base_price: '',
      base_time: '',
      categories: [],
    },
  )

  const handleNewServiceModal = () => {
    setNewServiceModal((prev) => !prev)
  }

  React.useEffect(() => {
    getAllServices()
  }, [])

  const getAllServices = async () => {
    let result = await getDataById('show-services')
    if (result?.success === true) {
      setServicesList(result?.data)
    }
  }

  React.useEffect(() => {
    let tempService = servicesList?.find(
      (el) => el.id === serviceData?.service?.id,
    )
    setNewService(tempService)
  }, [serviceData?.service?.id])

  const handleCreateNewService = async (e) => {
    if (e) {
      e.preventDefault()
    }
    let result
    let formData = new FormData()
    formData.append('stylist_id', user?.id)
    if (service) {
      formData.append('stylist_service_id', service?.id)
    }
    formData.append('description', serviceData?.description)
    formData.append('base_price', serviceData?.base_price)
    formData.append('base_time', serviceData?.base_time)
    formData.append('rates[]', JSON.stringify(rates))
    let images = []
    serviceData?.image?.forEach((item) => {
      if (typeof item !== 'string') {
        if (service) {
          formData.append('new_images[]', item)
        } else {
          formData.append('image[]', item)
        }
      } else {
        formData.append('old_images[]', item)
      }
    })
    if (typeof serviceData?.primary_image !== 'string') {
      formData.append('primary_image', serviceData?.primary_image)
    }
    formData.append('service_id', serviceData?.service?.id)
    formData.append('sub_service_id', serviceData?.subservice?.id)
    setFormData(formData)

    if (component === 'edit-profile' && service) {
      setIsLoading(true)
      result = await saveOrUpdateDataById('stylist-edit-service', formData)
      setIsLoading(false)
      getStylistServices()
      Swal.fire({
        title: 'Service Updated Successfully!',
        icon: 'success',
        timer: 2000,
        confirmButtonColor: '#2597F6',
      })
      handleCreateServiceModal(false)
      return
    } else {
      handleCreateServiceModal(false)
      handleNewServiceModal()
    }
    if (service) {
      setSkillRate((prev) => ({ ...prev, ...skillRate }))
      handleCreateServiceModal(false)
    }
  }

  const handleChange = (e) => {
    setServiceData((prev) => ({ ...prev, [e.target.name]: e.target.value }))
  }

  const handleServicePriceRateModal = () => {
    setServicePriceModal((prev) => !prev)
  }

  const handleImageUpload = async (e) => {
    e.persist()
    if (!e.target.files[0]) return
    const formData = new FormData()
    formData.append('file', e.target.files[0])
    setIsLoading(true)
    const response = await getDataById('upload-file', formData)
    setIsLoading(false)
    if (response?.success === true) {
      // URL.createObjectURL(e.target.files[0])
      setServiceData((prev) => ({
        ...prev,
        primary_image: e.target.files[0],
        primary_image_url: response?.data,
      }))
    }
  }

  const handleProductImageUpload = (e) => {
    e.persist()
    if (!e.target.files[0]) return
    let arr = []
    if (serviceData && serviceData.image) {
      arr = [...serviceData?.image]
    }
    arr.push(e.target.files[0])
    setServiceData((prev) => ({
      ...prev,
      image: [...arr],
    }))
  }

  return (
    <>
      <ScaleLoader
        color="#36d7b7"
        loading={isLoading}
        style={{
          position: 'fixed',
          left: 0,
          right: 0,
          height: '100%',
          top: 0,
          display: 'flex',
          zIndex: 1500,
          justifyContent: 'center',
          alignItems: 'center',
          backdropFilter: 'blur(10px)',
          background: '#ffffff00 0% 0% no-repeat padding-box',
        }}
      />
      <Modal
        open={createServiceModal}
        onClose={() => handleCreateServiceModal(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} className="modal-width">
          <div className="text-center">
            <h3 className="fs-24 mb-4 fw-bold">
              {isNewService === false ? 'Edit Service' : 'Create Service'}
            </h3>
            <form onSubmit={handleCreateNewService}>
              <div className="m-auto">
                <label
                  htmlFor="service-primary-image"
                  className="edit-profile-modal p-4 pointer position-relative"
                  style={{
                    backgroundImage: `linear-gradient(${
                      serviceData?.primary_image
                        ? 'rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5))'
                        : 'rgba(247, 247, 247, 0.5), rgba(247, 247, 247, 0.5))'
                    }, url(${
                      typeof serviceData?.primary_image === 'string'
                        ? serviceData?.primary_image
                        : serviceData?.primary_image_url
                      // &&
                      //   URL.createObjectURL(serviceData?.primary_image)
                    })`,
                    border: '1px solid #AAA5A5',
                    width: '140px',
                    height: '137px',
                  }}
                >
                  <div>
                    <img
                      src={CreateServiceCameraIcon}
                      alt=""
                      height={25}
                      width="auto"
                    />
                    <p
                      style={
                        serviceData?.primary_image
                          ? { color: '#ffffff', fontSize: '9px' }
                          : { color: '#BBBBBB', fontSize: '9px' }
                      }
                      className="mt-1"
                    >
                      Change profile picture
                    </p>
                  </div>
                  <TextField
                    type="file"
                    name="profile-image"
                    onChange={handleImageUpload}
                    id="service-primary-image"
                    style={{ display: 'none' }}
                  />
                </label>
              </div>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-2"
                  margin="dense"
                >
                  Service Category
                </FormHelperText>
                <Select
                  value={serviceData?.service?.id || ''}
                  defaultValue={serviceData?.service?.id || ''}
                  name="service_id"
                  fullWidth
                  onChange={(e) => {
                    const service = servicesList.find(
                      (s) => s.id === e.target.value,
                    )
                    setServiceData((prev) => ({ ...prev, service }))
                  }}
                >
                  {servicesList.map((service) => (
                    <MenuItem
                      key={service?.id}
                      value={service?.id}
                      className="text-capitalize"
                    >
                      {service.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-2"
                  margin="dense"
                >
                  Sub-Service Category
                </FormHelperText>
                <Select
                  defaultValue={serviceData?.subservice?.id || ''}
                  value={serviceData?.subservice?.id || ''}
                  fullWidth
                  name="subservice"
                  sx={{ width: '100% !important' }}
                  onChange={(e) => {
                    let subservice = newService?.subservices.find(
                      (el) => el.id === e.target.value,
                    )
                    setSelectedSubService(subservice)
                    setRates(subservice?.category)
                    setServiceData((prev) => ({ ...prev, subservice }))
                  }}
                >
                  {newService?.subservices?.map((service) => (
                    <MenuItem
                      key={service?.id}
                      value={service?.id}
                      className="text-capitalize"
                    >
                      {service.name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-2"
                  margin="dense"
                >
                  Price Rate
                </FormHelperText>
                <div className="pointer" onClick={handleServicePriceRateModal}>
                  <OutlinedInput
                    margin="dense"
                    placeholder="Select Price"
                    name="price_rate"
                    fullWidth={true}
                    className="p-0"
                    type="text"
                    value={serviceData?.base_price}
                    required
                    style={{ pointerEvents: 'none' }}
                    endAdornment={
                      <ChevronRightIcon
                        sx={{
                          color: '#08C4BB',
                          fontSize: '1.2rem',
                          marginRight: '.5rem',
                        }}
                      />
                    }
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-2"
                  margin="dense"
                >
                  Description
                </FormHelperText>
                <textarea
                  className="customer-support-message p-2"
                  name="description"
                  cols="30"
                  rows="5"
                  style={{ border: '1px solid #08C4BB', borderRadius: '8px' }}
                  value={serviceData?.description}
                  onChange={handleChange}
                ></textarea>
              </div>
              <div>
                <FormHelperText
                  id="input-label"
                  className="mt-2"
                  margin="dense"
                >
                  Product Images
                </FormHelperText>
                <div className="d-flex justify-content-start align-items-center flex-nowrap overflow-auto mt-1 gap-2">
                  <label
                    className="upload-service-image-button pointer"
                    htmlFor="add-service-image"
                  >
                    <span>
                      <AddIcon sx={{ color: '#000', fontSize: '1.5rem' }} />
                    </span>
                    <input
                      type="file"
                      className="d-none"
                      id="add-service-image"
                      onChange={handleProductImageUpload}
                    />
                  </label>
                  <div className="row flex-nowrap overflow-auto g-2">
                    {serviceData &&
                      serviceData.image &&
                      serviceData?.image?.map((url, index) => (
                        <div
                          className="product-image-container position-relative"
                          key={index}
                        >
                          <div
                            style={{
                              position: 'absolute',
                              top: '3%',
                              right: '7%',
                              backgroundColor: '#E4E4E4',
                              borderRadius: '50%',
                              width: '16px',
                              height: '16px',
                              display: 'flex',
                            }}
                          >
                            <ClearIcon
                              sx={{
                                color: '#FF0000',
                                cursor: 'pointer',
                                fontSize: '1rem',
                              }}
                              className="delete-new-service-product-image"
                              onClick={() => {
                                let arr = serviceData?.image
                                arr.splice(index, 1)
                                setServiceData((prev) => ({
                                  ...prev,
                                  image: [...arr],
                                }))
                              }}
                            />
                          </div>
                          <img
                            src={
                              typeof url === 'string'
                                ? url
                                : URL.createObjectURL(url)
                            }
                            alt=""
                          />
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <Button
                fullWidth={true}
                disableElevation
                className="mt-4"
                type="submit"
                id="btn-primary-no-shadow"
              >
                Continue
              </Button>
            </form>
          </div>
        </Box>
      </Modal>
      <SetSkillRateModal
        setSkillRateModal={servicePriceModal}
        handleSetSkillRateModal={handleServicePriceRateModal}
        component={'create-service'}
        setSkillRate={setServiceData}
        skillRate={serviceData}
        selectedService={newService}
        selectedSubService={selectedSubService}
        rates={rates}
        setRates={setRates}
        handleCreateServiceModal={handleCreateServiceModal}
      />
      <NewServiceModal
        handleNewServiceModal={handleNewServiceModal}
        newServiceModal={newServiceModal}
        service={serviceData}
        formData={formData}
        component={component ? "sign-up" : 'edit-profile'}
        selectedSubService={selectedSubService}
        setServiceData={setServiceData}
        getStylistServices={getStylistServices}
        handleCreateServiceModal={handleCreateServiceModal}
        // handleAddOrEditSkillsModal={handleAddOrEditSkillsModal}
      />
    </>
  )
}

export default CreateServiceModal
